import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmspace/cecUnmItem/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmspace/cecUnmItem/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmspace/cecUnmItem/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/unmspace/cecUnmItem/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmspace/cecUnmItem/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmspace/cecUnmItem/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmspace/cecUnmItem/import',
      method: 'post',
      data: data
    })
  }
}
